import { FC, memo } from 'react';
import { AlertType } from './types';
import { twMerge } from 'tailwind-merge';
import { descriptionStyles } from './alert.styles';

type AlertDescriptionProps = {
  type: AlertType;
  text: string;
};

const AlertDescriptionComp: FC<AlertDescriptionProps> = ({ text, type }) => {
  return <p className={twMerge('text-sm text-tertiary-600', descriptionStyles({ type }))}>{text}</p>;
};

export const AlertDescription = memo(AlertDescriptionComp);
